import { OpenHouseEntry } from "../../../interfaces/interfaces";
import React from 'react'
import { useRecoilValue } from 'recoil';
import * as AppState from '../../../AppState';
import AddToCalendarLink from "./AddToCalendarLink";
import classNames from "classnames";
import './OpenHouseListItem.scss'


export const OpenHouseListItem = (props: {OpenHouse: OpenHouseEntry, address: string, hidden: boolean}) =>{

  const locale = new Intl.Locale('en-US');
  const userOnMobile = useRecoilValue(AppState.gsIsMobile);

  const toReadableDateRange = (startTime: string, endTime: string) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const timeOptions: Intl.DateTimeFormatOptions = {hour: "numeric", minute:"numeric"};
    if(start.toDateString === end.toDateString){
      return `${start.toLocaleTimeString(locale, timeOptions)} - ${end.toLocaleTimeString(locale, timeOptions)}`
    }
    else {
      return `${start.toDateString()}: ${start.toLocaleTimeString(locale, timeOptions)} - ${end.toDateString()}: ${end.toLocaleTimeString(locale, timeOptions)}`
    }
  }

  const eventDetails = {
    eventName: `CapCenter Open House ${props.address}`,
    startDate: new Date(props.OpenHouse.OpenHouseStartTime), // April 10, 2024, 12:00 PM
    endDate: new Date(props.OpenHouse.OpenHouseEndTime),   // April 10, 2024, 1:00 PM
    details: `${props.OpenHouse.OpenHouseRemarks ?? `Open house for ${props.address}
${new Date(props.OpenHouse.OpenHouseStartTime).toDateString()} from ${toReadableDateRange(props.OpenHouse.OpenHouseStartTime, props.OpenHouse.OpenHouseEndTime)}`}
${window.location.href}`,
    location: props.address
  };

  return userOnMobile?
  <article className={classNames("shadow border-radius text-center col-12 col-sm-10 col-md-8 py-4 my-3 rounded", props.hidden ? 'open-house-list-item-hidden' : '')}>
    <h4>
      {new Date(props.OpenHouse.OpenHouseStartTime)
        .toLocaleDateString(
          locale,
          {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
      }
    </h4>
    <div>
      <h5>{toReadableDateRange(props.OpenHouse.OpenHouseStartTime, props.OpenHouse.OpenHouseEndTime)}</h5>
    </div>
    {props.OpenHouse.OpenHouseRemarks &&
      <div>
        {props.OpenHouse.OpenHouseRemarks}
      </div>
    }
    <AddToCalendarLink {...eventDetails} />
  </article>:
  <article className={classNames("text-center py-3", props.hidden ? 'open-house-list-item-hidden' : '')}>
    <h4>
      {new Date(props.OpenHouse.OpenHouseStartTime)
        .toLocaleDateString(
          locale,
          {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        }
      </h4>
    <div>
      <h5>{toReadableDateRange(props.OpenHouse.OpenHouseStartTime, props.OpenHouse.OpenHouseEndTime)}</h5>
    </div>
    {props.OpenHouse.OpenHouseRemarks &&
      <div>
        {props.OpenHouse.OpenHouseRemarks}
      </div>
    }
    <AddToCalendarLink {...eventDetails} />
  </article>
}
